import { useState, useEffect } from 'react';
import { FormControlLabel, Checkbox } from '@/theme/index';
import {
  NEGATIVES_OPTIONS_FOR_UNCHECK,
  Container,
  StyledButton,
} from './constants';
import { SimpleQuestionSurveyProps } from '../DynamicQuestionsService/constants';

/**
 * This component lives in the QuestionsSurvey aka Onboarding Questions(DQS),
 * it's being rendered when the input_type is checkbox.
 * It renders a list of checkbox with the answer options.
 * It also reviews if the user selects a negative option
 * and if so, it unchecks the other options.
 */
export const OnboardingCheckbox = ({
  answerSet,
  screenId,
  customAttribute,
  storeAnswer,
}: SimpleQuestionSurveyProps) => {
  const [answers, setAnswers] = useState<string[]>([]);
  const [negativeOptionSelected, setNegativeOptionSelected] = useState(false);

  useEffect(() => {
    setAnswers([]);
  }, [answerSet]);

  const handleCheckboxChange = (newAnswer: string) => {
    if (answers.includes(newAnswer)) {
      setAnswers((prevAnswers) =>
        prevAnswers.filter((answer) => answer !== newAnswer)
      );
    } else if (NEGATIVES_OPTIONS_FOR_UNCHECK.includes(newAnswer)) {
      setAnswers([newAnswer]);
      setNegativeOptionSelected(true);
    } else if (negativeOptionSelected) {
      setAnswers([newAnswer]);
      setNegativeOptionSelected(false);
    } else {
      setAnswers((prevAnswers) => [...prevAnswers, newAnswer]);
    }
  };
  return (
    <>
      <Container>
        {answerSet.map((answerOption) => (
          <FormControlLabel
            key={answerOption}
            control={
              <Checkbox
                onChange={() => handleCheckboxChange(answerOption)}
                checked={answers.includes(answerOption)}
              />
            }
            label={answerOption}
          />
        ))}
      </Container>
      <StyledButton
        color="primary"
        disabled={!answers.length}
        variant="contained"
        onClick={() =>
          storeAnswer({
            screen_id: screenId,
            custom_attribute: customAttribute,
            response: answers,
          })
        }
      >
        Continue
      </StyledButton>
    </>
  );
};
